<template>
    <div id="view">
        <div class="wallroom">
            <div class="row">
                <div v-for="item in cctv_list" :key="item.cctv_id" class="col-md-6">
                    <div class="cam">
                        <div class="panel-cam">
                            <iframe class="cctv-cam" :src="'cctv.html?ws='+item.cctv_asset_id2" width="100%" frameborder="0" scrolling="no" onload="resizeIframe(this)"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { STREAMING_URL } from '../.env';

export default {
    name: "View",
    data() {
        return {
            cctv_list: []
        }
    },
    mounted() {
        //console.log(this.$route.query.id)
        if(this.$route.query.id != undefined){
            this.$route.query.id.split(',').forEach(ele => {
                this.cctv_list.push({
                    cctv_id: ele,
                    cctv_asset_id2: STREAMING_URL+ele+'/',
                })
            });
        }
    },
}
</script>

<style>
     [class*="col-"]{
        padding: 0;
    }
    .bg-gradient-primary{
        background-color: transparent;
        background-image: none;
    }
    .cam img{
        width: 100%;
        height: 225px;
        object-fit: cover;
    }
    .cctv-cam{
        display: flex;
        justify-content: center;
        width: 100%;
        /* height: 360px; */
        height: auto;
        background-color: #000;
        border: none;
    } 
    
</style>